import * as React from 'react';
import './index.scss';

interface Props {
    children?: React.ReactNode;
    onClick?: () => void;
}

const ButtonExternal = (props: Props) => (
    <button className="btn-external" onClick={props.onClick}>{props.children}</button>
);

export default ButtonExternal;


// WEBPACK FOOTER //
// ./src/components/layout/buttons/External/index.tsx